export default {
      id: "session-scheduled-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#session-scheduled",
      toString: function () {
        return this.url;
      }
    }